module.exports = __webpack_public_path__ + "img/1.84bab8bf.png";